angular.module('aprima-provider-api').factory('SigRepository',
    ['AprimaRestangular', 'AprimaAnalytics',
        function (AprimaRestangular, AprimaAnalytics) {
            'use strict';

            return {
                getSig: getSig,
                getSigwriterResults: getSigwriterResults
            };

            function getSig(medicationSigId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('SigRepository', 'api', 'get sig');
                var restangular = AprimaRestangular.get(restangularOptions);
                return restangular.all('sigs').one(medicationSigId).get().finally(timing.stop);
            }

            function getSigwriterResults(sigType, medicationSigId, restangularOptions) {
                restangularOptions = restangularOptions || {ignoreCache: false};
                var timing = AprimaAnalytics.startTiming('SigRepository', 'api', 'getSigwriterResults');
                var restangular = AprimaRestangular.get(restangularOptions);
                var opts = {
                    sigType: sigType,
                };
                return restangular.all('sigs/sigwriter-results')
                                  .one(medicationSigId)
                                  .get(opts)
                                  .finally(timing.stop);
            }
        }]);